import { FC } from 'react';
import { useParams } from 'react-router';
import { PageContainer } from '../../components/page/PageContainer';
import { PageHeader } from '../../components/page/PageHeader';
import { PageSizer } from '../../components/page/PageSizer';
import strings from './documents.translations';
import { NavPage } from '../../components/page/Breadcrumbs';
import { SearchBar } from '../../components/file/SearchBar';
import { DocumentListSection } from '../../components/oneDrive/DocumentList';
import { FaSearch } from 'react-icons/fa';
import { useSearchResults } from '../../services/graph/hooks/documentHelper';
import { useIntroduction } from '../../services/graph/hooks/introduction';

export const SearchResultsPage: FC = () => {
  const { searchTerm } = useParams<'searchTerm'>();

  if (!searchTerm) {
    throw Error("Search term must be supplied");
  }

  const introduction = useIntroduction();

  if (!introduction.data) {
    throw Error("Could not get image data");
  }

  const breadcrumbs: NavPage[] = [
    {
      name: strings.common.pages.documents,
      to: '/documents'
    },
    {
      name: strings.common.search,
      to: `/documents/search`
    },
    {
      name: searchTerm,
      to: `/documents/search/${searchTerm}`
    }
  ];

  return (
    <PageContainer>
      <PageHeader
        title={strings.common.search}
        description={strings.search.resultsDesc(searchTerm)}
        imageUrl={introduction.data.backgroundImages.searchPage}
        breadcrumbs={breadcrumbs}
      />
      <PageSizer className="py-5 flex flex-col gap-10">
        <SearchBar initialTerm={searchTerm} />
        <DocumentListSection
          title={strings.search.resultsDesc(searchTerm)}
          Icon={FaSearch}
          getDocuments={() => useSearchResults(searchTerm)}
          filterable
          includeCategories
        />
      </PageSizer>
    </PageContainer>
  );
};
